export const E_WALLET_IS_NOT_IDENTIFIED = '8b578400-c91d-4536-8f1f-c83edd95b07e';
export const E_WALLET_OWNER_IS_NOT_MATCHED_TO_CLIENT = 'a591fdd6-2788-40d7-bb18-5dc67ed06864';
export const NOT_UNIQUE = '3acc7587-06f6-4559-b388-c5f9a816e6d8';
export const UNDER_AGE = '4e933b16-43fc-428e-914f-bcf5a5bebd5e';
export const NOT_VALID_EMAIL = 'invalid_email';
export const NOT_VALID_EMAIL_2 = 'bd79c0ab-ddba-46cc-a703-a7a4b08de310';
export const NOT_VALID_FORMAT_ID_NUMBER = '959e701e-c6f4-486e-8a7f-21f9845ce3df';
export const NOT_VALID_PASSWORD = 'de1e3db3-5ed4-4941-aae4-59f3667cc3a3';
export const NOT_VALID_PHONE_NUMBER = '5d442214-7563-4ab1-9ab3-cdc5339b746c';
export const TELEPHONE_ID_USED = 'bf13d46d-47d1-4220-9f17-3fc76ad46c47';
export const AUTHORITY_TOO_LONG_1 = '959e701e-c6f4-486e-8a7f-21f9845ce3df';
export const AUTHORITY_TOO_LONG_2 = 'd94b19cc-114f-4f44-9cc4-4138e80a87b9';
export const E_WALLET_NOT_VALID = '959e701e-c6f4-486e-8a7f-21f9845ce3df';
export const ERROR_VALUE_IN_CYRILLIC = '49eacac2-1c7d-4a88-a117-66c51cff56c7';
export const BIOMETRY_EXPIRED = '709f3be1-0121-48fa-9cf8-ef51b8605ab1';
export const INVALID_VERIFICATION_CODE = '01c71406-ba85-4b65-a1e1-a872946db43a';
export const INVALID_EMAIL_VERIFICATION_CODE = '1f2bb14f-faaa-41c0-b985-7ad03683c286';
export const CREDENTIALS_INVALID = 'Credentials invalid';
export const USER_BLOCKED = 'User is blocked.';
export const NOT_SENT_CODE = 'Code not found by given identity';
export const NOT_PASSED_PHONE_VERIFICATION = 'Phone verification not passed';
export const SMS_CODE_VALIDATION_ERROR = 'validationError';
export const ALREADY_SENT_IN_LAST_MINUTE = '3f812f20-93db-4cca-b8e1-486583dd0c30';
export const DAY_LIMIT_GET_SMS = '7545bf56-4b01-4226-beb4-5d1a7af46888';
export const TOO_FREQUENT_ATTEMPTS = 'too_frequent_attempts';
export const TOO_MANY_ATTEMTPS = 'too_many_attempts';
export const INCORRECT_CREDENTIALS = 'ca569bcb-0cda-43c7-85df-682139f6c63d';
export const CLIENT_NOT_FOUND = '6dc2c33c-0298-4b3f-93e4-12c383de6385';
export const DATA_ALREADY_EXIST = 'e83534b8-6773-4ec4-8635-e098464ddc0e';
export const FORM_VALIDATION_ERROR = '09ccbada-5a82-4e27-882c-1c3952dca1f4';
export const INVALID_EMAIL_DOMAIN = 'invalid_email_domain';
export const PASSWORD_TOO_SHORT = '9ff3fdc4-b214-49db-8718-39c315e33d45';
export const PASSWORD_TOO_LONG = 'd94b19cc-114f-4f44-9cc4-4138e80a87b9';
export const PASSWORD_CHARS_COMPLEXITY = '2b0de5e4-a151-42ce-9855-575ec6dc084d';
export const TOO_MANY_REQUESTS = 'c675267c-09ab-4716-b4b1-d7bb930378f7';
export const SAME_PASSWORD = 'c3cb4b83-5e23-4d29-aea8-d207604dc564';
export const API_RATE_LIMIT_EXCEEDED = 'API rate limit exceeded';
export const VIDEO_UPLOAD_ERRORS = {
  REQUIRED: 'Video file is required.',
  TOO_LARGE: 'The file is too large',
  NOT_ALLOWED: 'Only video files are allowed.',
  EMPTY: 'Video file is empty.',
};

export const serverErrors = {
  internal_error: 500,
  forbidden: 403,
  bad_request: 400,
};

export const successfulStatusCode = Object.freeze({
  no_content: 204,
});
